import React from 'react';
import { call, put } from 'redux-saga/effects';
import { ConnectionClosedError } from '@pearsontechnology/aero-rtm';
import { FormattedMessage } from 'react-intl';
import * as connMgrActions from 'containers/ConnectionManager/actions';
import { pushToast } from 'containers/ToastManager/actions';
import connMgrMessages from 'containers/ConnectionManager/messages';

export default function* catchErrors(generatorFunc, ...args) {
  try {
    yield call(generatorFunc, ...args);
  } catch (error) {
    if (error instanceof ConnectionClosedError) {
      yield put(connMgrActions.serverRequestError(<FormattedMessage {...connMgrMessages.connectionDownError} />));
      yield put(pushToast({
        type: 'simple',
        message: <FormattedMessage {...connMgrMessages.connectionDownError} />,
      }));
    } else {
      yield put(connMgrActions.serverRequestError(error.message));
      yield put(pushToast({
        type: 'simple',
        message: error.message,
      }));
    }
  }
}
